import { motion, useReducedMotion } from "framer-motion";
import { EASE } from "@/lib/motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1.1, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

const line = {
  hidden: { y: "108%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.15, ease: EASE, delay: i * 0.09 } }),
};

// Masked line-by-line reveal; observer sits on the unclipped wrapper.
export const MaskedLines = ({ lines, delay = 0, inView = false, className = "", lineClass = () => "" }) => {
  const reduce = useReducedMotion();
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span
      className={`block ${className}`}
      initial={reduce ? false : "hidden"}
      transition={{ delayChildren: delay }}
      {...trigger}
    >
      {lines.map((l, i) => (
        <span key={l} className={`block overflow-hidden pb-[0.1em] -mb-[0.1em] ${lineClass(i)}`}>
          <motion.span className="block will-change-transform" variants={line} custom={i + delay / 0.09}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
